<template>
  <div class="content" :class="[
    route.meta.transparency_Head == true
      ? 'transparency-head'
      : 'header-content',
    isScrolled ? 'scroll' : '',
  ]">
    <t-head-menu :defaultValue="routethen" v-model="routethen" theme="light" height="120px" expand-type="popup">
      <!-- <template #logo> 中学智慧课堂 </template> -->
      <template #logo>
        <!-- <i class="iconfont icon-sgktlogo"></i> -->
        <div class="logo">
          <img v-if="platform.iconUrl" :src="platform.iconUrl" alt="" />&nbsp;
          <span>{{ platform.name }}</span>
        </div>
      </template>
      
      <template v-for="(items, index) in menuData" :key="index + 'h'">
        <!-- 一级菜单 -->
        <t-menu-item :value="items.component" 
          v-bind="/^https?:\/\//.test(items.path) ? { href: items.path, 'target': '_blank' } : { to: items.path }"
          v-if="!items.naviationListResList">
          {{ items.name }}
        </t-menu-item>
        <!-- 二级菜单 -->
        <t-submenu :title="items.name" :value="items.component" v-else>
          <t-menu-item v-for="sonmenu in items.naviationListResList" :key="sonmenu.component" :value="sonmenu.component"
            :to="sonmenu.path">{{ sonmenu.name }}</t-menu-item>
        </t-submenu>
      </template>
      
      <template #operations v-if="getToken">

        <t-button variant="text" shape="square" @click="clickAppShow">
          <i name="translateS" class="iconfont icon-shitu"></i>
        </t-button>

        <!-- 语言切换 -->
        <t-space class="tdesign-demo-dropdown">
          <t-dropdown :options="optionsLang" trigger="click" @click="clickLang">
              <t-button variant="text" shape="square"> 
                  <icon-font name="translate" size="25px" />
              </t-button>
          </t-dropdown>
        </t-space>

        <t-button variant="text" shape="square">
          <t-popup
            :visible="visible"
            placement="bottom-left"
            :on-visible-change="onVisibleChange"
            :overlay-inner-style="
              (triggerElem) => ({
                padding: 0,
                marginRight: '-10px',
                overflow: 'hidden',
              })
            "
          >
            <t-badge
              v-if="numVal !== 0"
              dot
              :count="100"
              :offset="[4, 6]"
              style="line-height: 16px"
            >
              <i
                name="notification"
                @click="onToggle"
                style="z-index: 0"
                class="iconfont icon-a-Frame15971"
              ></i>
            </t-badge>
            <i
              v-else
              name="notification"
              @click="onToggle"
              class="iconfont icon-a-Frame15971"
            ></i>
            <template #content>
              <MessageList
                ref="myRefMessageList"
                @onNumVal="onNumVal"
              ></MessageList>
            </template>
          </t-popup>
        </t-button>
        <!-- @mouseenter="handleMouseEnter" -->
        <div class="curde" id="handleMouseEnter">
          <t-avatar :image="avatar ? avatar : require('@/assets/Front/user.png')" :onerror="imgError"
            @click="goUserInfoView" />
          <!-- @mouseleave="handleMouseLeave" -->
          <div class="DropdownWX" v-show="DropdownWX" id="handleMouseLeave">
            <div class="back">
              <div class="userInfoView">
                <t-avatar :image="avatar ? avatar : require('@/assets/Front/user.png')
    " @click="goUserInfoView" size="48px" />
                <h3>{{ userInfo.name }}</h3>
                <p>{{ userInfo.schoolName }}</p>
                <div class="line"></div>
              </div>
              <ul>
                <li v-for="item in options" :key="item.value" @click="clickHandler(item)">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="item.icon"></use>
                  </svg>
                  {{ item.content }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </template>

      <template #operations v-else>

       <!-- 语言切换 -->
       <t-space class="tdesign-demo-dropdown">
          <t-dropdown :options="optionsLang" trigger="click" @click="clickLang">
              <t-button variant="text" shape="square"> 
                  <icon-font name="translate" size="25px" />
              </t-button>
          </t-dropdown>
        </t-space>

        <t-button wx_btnLogin @click="gologin">
          {{ $t('share.logOn') }}
          </t-button>
      </template>
    </t-head-menu>
    <div class="goTop" v-if="goTop" @click="goToTop">
      <img src="../../assets/rocket.png" alt="" />
      <span>{{ $t('share.backTop') }}</span>
    </div>
  </div>
  <t-dialog header="请选择身份" width="488" :visible.sync="selectIdentity" :onCloseBtnClick="esclogin" :destroyOnClose="true"
    :footer="false">
    <IdentitySwitch :identity="Identity" @close="esclogin" @submitbtn="Identitysub" :defaultState="true" />
  </t-dialog>

  <AppList ref="applicationList" ></AppList>
</template>
<script setup>
import Cookies from "js-cookie";
import { logout } from "@/api/login";
import {
  getCurrentInstance,
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  reactive,
} from "vue";
const { $eventBus } = getCurrentInstance().appContext.config.globalProperties;
import { MessagePlugin } from "tdesign-vue-next";
import { IconFont } from "tdesign-icons-vue-next";
import { useRouter, useRoute } from "vue-router";
import MessageList from "./MessageList.vue";
import { baseReadNoticeCount } from "@/api/teaching.js";
import AppList from "@/components/AppList";
import { navigation, getRoleMenuByUserId } from "@/api/limitsOfAuthority.js";
import { getGroupList } from "@/api/homepageLive.js";
import { getInfoInDividuation, EqumentDataView } from "@/api/Equipment.js";
import { getUserInfo, getUserfileimg } from "@/api/base.js";
import { switchIdentity, getloginIdentity } from "@/api/login.js";
import { getUserRoleList } from "@/api/01-publicAxios.js";
import { NewWebSocket } from "./IMSocket.js";
import { useStore } from "vuex";
import { isIPAddress } from "@/utils/handleUrl";
import IdentitySwitch from "./Identity/index.vue";
import $ from "jquery";
import i18n from "@/utils/i18n";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const store = useStore();
const router = useRouter();
const route = useRoute();
// 尝试从 Cookie 中获取 userInfo 字符串
const userInfoString = Cookies.get("userInfo");

// 尝试解析 userInfo 字符串为对象，如果解析失败则返回空对象
let initialUserInfo = {};
try {
  initialUserInfo = userInfoString ? JSON.parse(userInfoString) : {};
} catch (error) {
  console.error("Error parsing userInfo from Cookie:", error);
}

const userInfo = ref(initialUserInfo);

const avatar = ref("");
const userId = ref("");
const applicationList = ref(null);

if (userInfo.value) {
  userId.value = userInfo.value.userId;
}

let getSchoolId = "";
if (Cookies.get("schoolId")) {
  getSchoolId = Cookies.get("schoolId");
}

var getToken = Cookies.get("tokenValue");
const Identity = ref(localStorage.getItem("Identity")); // 身份id（1：管理员、2：教师、3：学生、4：家长、5：游客）
const myRefMessageList = ref(null);
const isScrolled = ref(false);
const options = ref([
  {
    content: t('share.backstageManagement'),
    value: 2,
    path: "/wenxiang_Backstage",
    icon: "#icon-Union",
  },
  // {
  //   content: t('share.SwitchIdentity'),
  //   value: 10,
  //   path: "",
  //   icon: "#icon-qiehuanjiaose",
  // },
  {
    content: t('share.SignOut'),
    value: 3,
    path: "",
    icon: "#icon-logout",
  },
]);

const emit = defineEmits(["onGlobalSwitchLang"]);

//打开应用弹窗
function clickAppShow() {
  applicationList.value.Openadd()
}

const optionsLang = [
  {
    content:'简体中文',
    value: 'zh',
  },
  {
    content:'English',
    value: 'en',
  },
  {
    content:'日本語',
    value: 'ja',
  },
];
function clickLang(data) {

  // 语言切换
  window.g.LANG = data.value
  localStorage.setItem("lang", data.value);
  i18n.global.locale.value = data.value;
  store.dispatch("setLang", data.value);
  emit("onGlobalSwitchLang");
  document.title = t("PlatformName");
}
const userIdentiy = () => {
  if (userInfo.value) {
    console.log("*********");
    console.log(options.value);
    console.log(parseInt(Identity.value));
    switch (parseInt(Identity.value)) {
      case 1:
        console.log("管理员", Identity.value);
        options.value.unshift({
          content: t('share.PersonalSpace'),
          value: 1,
          path: "/wenxiang/TeacherSpace",
          icon: "#icon-a-Group15691",
        });
        getGroupList(userId.value, 1).then((res) => {
          if (res.code == 1 && res.data.length > 0) {
            options.value.unshift({
              content: t('share.Classspace'),
              value: 1,
              path: "/wenxiang/TeacherSpaceClassroom",
              icon: "#icon-a-Frame113023",
            });
          }
        });
        break;
      case 2:
        options.value.unshift({
          content: t('share.Teacherdashboard'),
          value: 1,
          path: "/wenxiang/TeacherSpace",
          icon: "#icon-a-Group15691",
        });
        getGroupList(userId.value, 1).then((res) => {
          if (res.code == 1 && res.data.length > 0) {
            options.value.unshift({
              content: t('share.Classspace'),
              value: 1,
              path: "/wenxiang/TeacherSpaceClassroom",
              icon: "#icon-a-Frame113023",
            });
          }
        });
        break;
      case 3:
        let ids = [2, 10]; // 学生去除 （管理后台、切换身份）
        ids.forEach((iditem) => {
          let index = options.value.findIndex((item) => item.value === iditem);
          if (index != -1) {
            options.value.splice(index, 1);
          }
        });
        // options.value.splice(0, 2); // 学生去除 （管理后台、切换身份）
        options.value.unshift({
          content: t('share.Studentdashboard'),
          value: 1,
          path: "/wenxiang/TeacherSpaceStudent",
          icon: "#icon-a-Frame113179",
        });
        break;
      default: // 4：家长、5：游客 去除 （管理后台、切换身份）
        options.value.splice(0, 1);
        break;
    }
  }
};

console.log("空间数据", options.value);
const getFrontMenu = () => {
  navigation({
    filterFieldOne: 2,
  }).then((res) => {
    if (res.code == 1) {
      res.data.forEach((element) => {
        element.naviationListResList&&element.naviationListResList.forEach((ele) => {
          if (!ele.naviationListResList||ele.naviationListResList.length == 0) {
            ele.naviationListResList = undefined;
          }
        });

        if (!element.naviationListResList||element.naviationListResList.length == 0) {
          element.naviationListResList = undefined;
        }
      });
      // console.log(res.data);
      menuData.value = res.data;
    }
  });
}
let getMenuData = async () => {
  if(getToken){
    await getRoleMenuByUserId(userId.value); //  新账号 登录需要调这个接口 初始化菜单 前台菜单 “数据” 菜单才会显示出来 
    await getFrontMenu();
  }else{
    await getFrontMenu();
  }
};
// 根据用户头像文件id获取头像地址
// const Userfileimg = (id) => {
//   if (!id) return;
//   getUserfileimg(id).then((res) => {
//     if (res.code === 1) {
//       if (res.data.accessPath && res.data.accessOutPath) {
//         let hostname = window.location.hostname;
//         if (isIPAddress(hostname)) {
//           // 内网
//           avatar.value = res.data.accessPath;
//         } else {
//           // 外网
//           avatar.value = res.data.accessOutPath;
//         }
//       } else {
//         avatar.value = res.data.accessPath
//           ? res.data.accessPath
//           : res.data.accessOutPath;
//       }
//       localStorage.setItem("avatar", avatar.value);
//     }
//   });
// };
// 获取用户信息
const getUserDetail = () => {
  if (userInfo.value.userId) {
    getUserInfo(userId.value).then((res) => {
      if (res.code === 1) {
        userInfo.value = res.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        avatar.value = res.data.avatar;
        localStorage.setItem("avatar", res.data.avatar ? res.data.avatar : "");
        // Userfileimg(res.data.avatar);
      }
    });
  }
};


// 图片裂开无法显示
const imgError = (e) => {
  let img = e.srcElement;
  img.src = require("@/assets/Front/user.png");
  img.onerror = null;
};


// 获取当前用户身份是否包含自定义的角色
// 中台过来的用户 且多个身份 可以切换身份 ，如果里面包含了智慧课堂的自定义身份角色 则隐藏切换身份，要么联系智慧课堂其他管理员
// 吧自定义分配的角色删除，要么联系中台管理员重新分配权限（重置）
const getUaserRoleSTATE = () => {
  getUserRoleList(userId.value).then((res) => {
    if (res.code === 1) {
      // 判断：true隐藏切换身份 false不隐藏
      if (res.data) {
        let index = options.value.findIndex((item) => item.value === 10);
        console.log(index + "身份位置"); // }
        if (index != -1) {
          options.value.splice(index, 1);
        }
      }
    }
  });
};

const menuData = ref([
  // {
  //   name: "首页",
  //   path: "/wenxiang/home",
  //   menuId: "home",
  // },
  // {
  //   name: "专递课堂",
  //   path: "/wenxiang/DeliveryClassroom",
  //   menuId: "DeliveryClassroom",
  // },
  // {
  //   name: "教研活动",
  //   path: "/wenxiang/TeachingActivities",
  //   menuId: "TeachingActivities",
  // },
  // {
  //   name: "系列课",
  //   path: "/wenxiang/SeriesCourse",
  //   menuId: "SeriesCourse",
  // },
  // {
  //   name: "精品课程",
  //   path: "/wenxiang/ExcellentCourse",
  //   menuId: "ExcellentCourse",
  //   children: [
  //     {
  //       name: "精品课程",
  //       path: "/wenxiang/ExcellentCourse?type=1",
  //       menuId: "ExcellentCourse1",
  //     },
  //     {
  //       name: "校园广播",
  //       path: "/wenxiang/ExcellentCourse?type=2",
  //       menuId: "ExcellentCourse2",
  //     },
  //     {
  //       name: "专题课",
  //       path: "/wenxiang/ExcellentCourse?type=3",
  //       menuId: "ExcellentCourse3",
  //     },
  //   ],
  // },
  // {
  //   name: "在线课堂",
  //   path: "/wenxiang/LiveStreamingActivities",
  //   menuId: "LiveStreamingActivities",
  // },
]);

const visible = ref(false);
const onToggle = () => {
  visible.value = !visible.value;
};
const numVal = ref(0);
const onNumVal = (val) => {
  numVal.value = val;
};
const getNumber = async () => {
  // 获取我的未读消息个数
  const res = await baseReadNoticeCount({
    pfType: 1,
    readFlag: 0,
  });
  if (res.code === 1) {
    numVal.value = res.data;
  }
};
getToken && getNumber();
const onVisibleChange = (v, context) => {
  if (context.trigger === "document") {
    visible.value = false;
  }
  // console.log(v, context);
};

// 下拉框
const DropdownWX = ref(false);
// const handleMouseEnter = () => {
//   DropdownWX.value = true;
// };
// const handleMouseLeave = () => {
//   DropdownWX.value = false;
// };

// 获取平台名称
const platform = reactive({
  name: "",
  iconUrl: "",
});
const getPlatForm = () => {
  let pfId = 2;
  getInfoInDividuation(pfId, getSchoolId).then((res) => {
    if (res.code === 1) {
      if (res.data) {
        // 传id修改
        platform.name = res.data.name;
        platform.iconUrl = res.data.iconUrl;
        window.document.title = res.data.name;
      }
    }
  });
  EqumentDataView().then((res) => {
    if (res.code === 1) {
      sessionStorage.setItem("publicLive",res.data.publicLive);// 公网直播 0关闭 /1开启
    }
  });
};

// 获取路由meta
const routethen = computed(() => {
  return route.meta.affiliation_Head;
});
const goTop = ref(false);
function clickHandler(data) {
  console.log(data);
  // MessagePlugin.success(`选中【${data}】`);
  if (data.value === 1) {
    //个人空间
    router.push({
      path: data.path,
    });
  } else if (data.value === 2) {
    // 管理后台
    router.push({
      path: data.path,
    });
  } else if (data.value === 10) {
    // 切换身份
    selectIdentity.value = true;
  } else {
    // 退出登录
    logout();
    store.commit("setSchoolId", "");
    localStorage.clear();
    Cookies.remove("schoolId");
    Cookies.remove("tokenValue", { domain: window.g.localName });
    Cookies.remove("userInfo");
    if ( Cookies.get('ssoType')=='1' && window.g.SingleSignOn ) {//单点登录退出跳转
      Cookies.remove('ssoType')
      if(window.g.SSO_OUT_Router){
        window.open(window.g.SSO_OUT_URL,'_self')
        return
      }
    }
    router.push({ path: "/login" });
    location.reload();
    // window.location.href = window.location.origin + "/login";
    
     
  }
}

function gologin() {
  router.push({ path: "/login" });
}

onMounted(() => {
  document.title = t("PlatformName"); // 设置页面title

  // 管理页面同步更新
  $eventBus.on("synchronization", () => {
    getMenuData();
  });
  // 监听用户信息管理修改操作同步更新
  $eventBus.on("updataUser", () => {
    getUserDetail();
  });
  // 监听个性话设置修改
  $eventBus.on("getPlatFormDetail", () => {
    getPlatForm();
  });
  //首次加载
  getMenuData();
  getPlatForm();
  getUserDetail();
  // 获取当前身份 角色
  if (userInfo.value.username) {
    getloginIdentity(userInfo.value.username).then((res) => {
      if (res.code === 1) {
        localStorage.setItem("Identity", res.data[0].identityId); // 存储当前登录身份id
        Identity.value = res.data[0].identityId;
        userIdentiy();
        // 3：学生、4：家长、5：游客 不执行
        if (Identity.value <= 2) {
          // 监听分配角色修改
          $eventBus.on("getUserRole", () => {
            getToken && getUaserRoleSTATE();
          });
          getToken && getUaserRoleSTATE();
        }
      }
    });
  }
  //后台菜单权限
  // getRoleMenuByUserId(userId).then((res) => {
  //   if (res.code == 1) {
  //     if (res.data.length == 0) {
  //       options.value = [
  //         {
  //           content: "退出登录",
  //           value: 3,
  //           path: "",
  //         },
  //       ];
  //     }
  //   }
  // });
  window.addEventListener("scroll", handleScroll);

  $("#handleMouseEnter")
    // .mouseenter(function () {
    //   $("#handleMouseLeave").show();
    // })
    .mouseleave(function () {
      $("#handleMouseLeave").hide();
    });
});
// 新增回到顶部函数
function goToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

function handleScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (scrollTop > 400) {
    goTop.value = true;
  } else {
    goTop.value = false;
  }
  isScrolled.value = scrollTop > 0;
}

// 实时获取消息列表变化
if (userInfo.value.userId) {
  const { WsDestroying } = NewWebSocket(() => {
    // console.log("参数", arguments);
    myRefMessageList.value && myRefMessageList.value.getList();
  });
}

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
  // if (WsDestroying) {
  //   WsDestroying();
  // }

  // 移除监听事件
  $eventBus.off("synchronization");
  $eventBus.off("updataUser");
  $eventBus.off("getPlatFormDetail");
  $eventBus.off("getUserRole");
});

const goUserInfoView = () => {
  // 跳转游客和学生的个人信息页
  $("#handleMouseLeave").show();
  // if (parseInt(Identity.value) === 3) {
  //   router.push({
  //     path: "/wenxiang/TeacherSpaceXuesheng",
  //   });
  // } else if (parseInt(Identity.value) === 5) {
  //   router.push({
  //     path: "/wenxiang/TeacherSpaceYouke",
  //   });
  // }
  // router.push({
  //   path: "/wenxiang/userInfo",
  // });
};

// 切换身份
const selectIdentity = ref(false);
const Identitysub = (event) => {
  switchIdentity(event).then((res) => {
    if (res.code === 1) {
      localStorage.setItem("Identity", event); // 存储当前登录身份id
      MessagePlugin.success("身份切换成功");
      location.reload();
    }
  });
};
const esclogin = () => {
  selectIdentity.value = false;
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
